module.exports = __webpack_public_path__ + "assets/icon-conductor-polywire.754c6c42.svg";